module.exports = __webpack_public_path__ + "media/src/images/site-top/image1-46de5a7b4f5baa148d0af8e212de7a4f.jpg";